import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from '../../../../store/reducer';
import * as types from './actionTypes';
import { Guide, GuideDescription } from 'data/ui/guide/Guide';
import { sleep } from 'util/sleep';
import { SELECTOR_MATCH_ALL } from './reducer';

export const selectGuide = (
  guideDesc: GuideDescription
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  const guide = (await import(
    `../../../../assets/json/guide/${guideDesc.detailFilePath}`
  )) as Guide;

  dispatch({
    type: types.SELECT_GUIDE,
    guide,
  } as types.SelectGuideAction);
};

export const completeGuideAction = (actionDone: string) => {
  return {
    type: types.COMPLETE_GUIDE,
    actionDone,
  } as types.CompleteGuideAction;
};

export const stopGuide = () => {
  return {
    type: types.STOP_GUIDE,
  } as types.StopGuideAction;
};

export const markGUIReady = (
  selectors: string[] | typeof SELECTOR_MATCH_ALL
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  const SAFE_DELAY_TIME_FOR_UI_TO_FINISH_RENDER = 500;
  await sleep(SAFE_DELAY_TIME_FOR_UI_TO_FINISH_RENDER);
  dispatch({
    type: types.MARK_GUI_READY,
    selectors,
  } as types.MarkGUIReadyAction);
};
